import { useTranslation } from "react-i18next";
import { Col } from "react-bootstrap";
import { DateField, InputField } from "./fields";
import { useProgramContext } from "./ProgramContext";

const HeaderFields = ({ control, formState, fieldName, isReadOnly = false }) => {
  const { t } = useTranslation(["programs"]);
  const { showHeaderFields, engine } = useProgramContext();
  const fieldNamespace = (name) => (fieldName ? `${fieldName}.${name}` : name);
  if (!showHeaderFields) return null;
  return (
    <>
      <Col xs={6}>
        <InputField
          label={t(($) => $.programs.header.Name)}
          placeholder={t(($) => $.programs.header.Name)}
          fieldName={fieldNamespace("name")}
          errors={formState.errors}
          control={control}
          rules={{ required: { value: true, message: t(($) => $.programs.header["Name is required"]) } }}
          disabled={isReadOnly}
        />
      </Col>
      <Col xs={3} className="d-flex flex-column align-items-end">
        <DateField
          label={t(($) => $.programs.header["Start Date"])}
          placeholder={t(($) => $.programs.header["Starting on..."])}
          fieldName={fieldNamespace("start_date")}
          errors={formState.errors}
          control={control}
          rules={{
            required: { value: true, message: t(($) => $.programs.header["Start date is required"]) },
          }}
          disabled={isReadOnly}
        />
      </Col>
      <Col xs={3} className="d-flex flex-column align-items-end">
        <DateField
          label={
            engine === "bidding" ?
              t(($) => $.programs.header["End Date (optional)"])
            : t(($) => $.programs.header["End Date"])
          }
          placeholder={t(($) => $.programs.header["Ending on..."])}
          fieldName={fieldNamespace("end_date")}
          errors={formState.errors}
          control={control}
          rules={{
            required: {
              value: engine === "pricing",
              message: t(($) => $.programs.header["End date is required"]),
            },
          }}
          disabled={isReadOnly}
        />
      </Col>
    </>
  );
};

export default HeaderFields;
